export default __webpack_public_path__ + "static/media/grafiken_memory_666x666_RS_01.cb4471eb.jpg";